// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes */
export default {
  "FIELD_DEF.cataloged": "Catalogué",
  "FIELD_DEF.catalogedBy": "Catalogué par",
  "FIELD_DEF.colorMode": "Mode couleur",
  "FIELD_DEF.isPanoramic": "Panoramique",
  "FIELD_DEF.created": "Créé",
  "FIELD_DEF.directoryPath": "Chemin du répertoire",
  "FIELD_DEF.documentText": "Compléter le texte",
  "FIELD_DEF.ExtensionWin": "Extension_NOLOC_fr",
  "FIELD_DEF.filename": "Nom de fichier",
  "FIELD_DEF.fileDescription": "Description",
  "FIELD_DEF.fileSize": "Taille du fichier",
  "FIELD_DEF.geometry": "Geo - Carte",
  "FIELD_DEF.height": "Hauteur",
  "FIELD_DEF.horizontalResolution": "Horizontal Resolution",
  "FIELD_DEF.keywords": "Mots-clés",
  "FIELD_DEF.lastModified": "Modifié",
  "FIELD_DEF.lastUpdated": "Changé",
  "FIELD_DEF.aliasMac": "Alias Mac",
  "FIELD_DEF.creatorMac": "Créateur pour Mac",
  "FIELD_DEF.fileTypeMac": "Type de fichier Mac",
  "FIELD_DEF.zoneMac": "Zone Mac",
  "FIELD_DEF.multipageCount": "Nombre de pages",
  "FIELD_DEF.numBands": "Nombre de bandes",
  "FIELD_DEF.path": "Chemin",
  "FIELD_DEF.ItemID": "ID d’élément",
  "FIELD_DEF.shortFilenameWin": "Nom de fichier court Win",
  "FIELD_DEF.thumbnailSize": "Taille de vue miniature",
  "FIELD_DEF.updatedBy": "Modifié par",
  "FIELD_DEF.verticalResolution": "Résolution verticale",
  "FIELD_DEF.volume": "Volume",
  "FIELD_DEF.watermarked": "Avec filigrane",
  "FIELD_DEF.watermarkURL": "Adresse Internet du filigrane",
  "FIELD_DEF.width": "Largeur",
  "FIELD_DEF.SuggestedKeywords": "Smart Keywords",
  "General.OK": "OK",
  "General.Cancel": "Annuler",
  "General.Save": "Enregistrer",
  "ABOUT": "À propos de",
  "ABOUT_API_TAB": "API",
  "ABOUT_VERSION": "Version",
  "ABOUT_EXTENSIS_URL": "www.extensis.com",
  "ABOUT_PORTFOLIO_SERVER": "Portfolio Server",
  "ABOUT_PORTFOLIO_VERSION": "Version 9.0",
  "ABOUT_SERVER_TAB": "Serveur",
  "accessOriginals": "Originaux des accès et des procédures",
  "ACCOUNT_TYPE": "Authentification",
  "ACCOUNT_TYPE_LDAP": "Service d'annuaire",
  "ACCOUNT_TYPE_MANUAL": "Natif (intégré)",
  "ACTIVE_DIRECTORY": "Active Directory",
  "ADD": "Ajouter",
  "addAsset": "Ajouter des ressources",
  "ALL_CATALOGS_GROUP": "Tous les catalogues",
  "API_CODE_REFERENCE": "Référence du code de l'API (English)",
  "API_CODE_REFERENCE_URL": "http://doc.extensis.com/api/portfolio/index.html",
  "API_DEVELOPER_COMMUNITY": "Communauté des développeurs",
  "API_DEVELOPER_COMMUNITY_URL": "https://forums.extensis.com/c/digital-asset-management/portfolio-api-developer-community",
  "API_PORTFOLIO_HELP": "Rubrique d'aide sur l'administration du serveur",
  "API_PORTFOLIO_HELP_URL": "https://helpdocs.extensis.com/fr/portfolio/administration/{version}/index.htm",
  "API_SECTION_1": "L'API de Portfolio propose aussi une interface commune pour que les développeurs puissent intégrer les catalogues Portfolio, les métadonnées de ressources, et le traitement multimédia dans les systèmes métier, les flux d'opérations personnalisés, et les infrastructures Web.",
  "API_SECTION_2_PART_1": "L'utilisation de l'API nécessite des licences, comme stipulé dans le ",
  "API_SECTION_2_PART_2": ". Pour consulter ou modifier les informations de licence, cliquez sur 'Licences' dans l'application Administration du serveur.",
  "API_SECTION_2_EULA": "CLUF de Portfolio",
  "API_SECTION_2_EULA_URL": "http://helpdocs.extensis.com/portfolio/{version}/administration/fr/Content/Legal/extensis-portfolio-eula.htm",
  "API_SECTION_2_PART_3": "En savoir plus :",
  "API_TOKEN_CREATE": "Ajouter nouveau jeton API",
  "APPLY": "Appliquer",
  "APP_PAGE_TITLE": "Administrateur de Portfolio",
  "ASSETS": "Éléments",
  "AT_TIME": "au moment",
  "AUTHENTICATION_ERROR": "L'authentification du service de répertoire a échoué. Veuillez vérifier votre nom d'utilisateur et mot de passe.",
  "BACKUP_BACKUP_BUTTON": "Sauvegarder",
  "BACKUP_BACKUP_LABEL": "Sauvegarder",
  "BACKUP_BACKUP_NOW_BUTTON": "Sauvegarder maintenant",
  "BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE": "Pour modifier l’emplacement de sauvegarde, arrêtez d’abord le serveur Portfolio.",
  "BACKUP_CONFIRMATION_VERBIAGE": "Sauvegarder maintenant? Le Portfolio sera hors ligne jusqu'à ce que la sauvegarde soit terminée.",
  "BACKUP_DIRECTORY_LABEL": "Stocker dans le répertoire",
  "BACKUP_DIRECTORY_ERROR_MSG": "Le répertoire de sauvegarde sélectionné est erroné.",
  "BACKUP_EXPLANATION_TEXT_1": "Extraire les sauvegardes et stocker en toute sécurité la base de données du serveur et les paramètres.\nIt ne sauvegarde pas vos fichiers de composants d'origine!",
  "BACKUP_EXPLANATION_TEXT_2": "Le serveur sera inaccessible durant les sauvegardes.",
  "BACKUP_FILES_LABEL": "Fichiers de sauvegarde",
  "BACKUP_FRIDAY_LABEL": "Vendredi",
  "BACKUP_MONDAY_LABEL": "Lundi",
  "BACKUP_MOST_RECENT_LABEL": "Sauvegarde la plus récente",
  "BACKUP_NEXT_SCHEDULED_LABEL": "Prochaine sauvegarde planifiée",
  "BACKUP_NOTIFICATIONS": "Envoyer des notifications par courriel après les sauvegardes et les restaurations",
  "BACKUP_NOTIFICATIONS_DISABLED_MSG": "Les notifications par courriel doivent être activés dans Paramètres généraux > Notifications par courriel",
  "BACKUP_PROGRESS_BACKING_UP": "Sauvegarde en cours",
  "BACKUP_PROGRESS_BACKING_UP_DATA": "Sauvegarde des données en cours...",
  "BACKUP_PROGRESS_BACKUP_CANCELLED": "Sauvegarde annulée",
  "BACKUP_PROGRESS_BACKUP_FAILED": "Échec de la sauvegarde",
  "BACKUP_PROGRESS_BACKUP_SUCCESSFUL": "Sauvegarde réussie",
  "BACKUP_PROGRESS_PREFLIGHT": "Vérification de l'espace disponible...",
  "BACKUP_PROGRESS_RESTARTING": "Redémarrage du serveur...",
  "BACKUP_PROGRESS_RESTORE_FAILED": "Échec de la restauration",
  "BACKUP_PROGRESS_RESTORE_SUCCESSFUL": "Restauration réussie",
  "BACKUP_PROGRESS_RESTORING": "Restauration en cours",
  "BACKUP_PROGRESS_RESTORING_DATA": "Restauration des données en cours...",
  "BACKUP_PROGRESS_SHUTTING_DOWN": "Fermeture du serveur en cours...",
  "BACKUP_PROGRESS_SUMMARY": "Étape {stepNum} sur {totalSteps}",
  "BACKUP_RESTORE_BUTTON": "Restaurer à partir du fichier de sauvegarde...",
  "BACKUP_RESTORE_CONFIRMATION_VERBIAGE": "Restaurer la sauvegarde maintenant? Le portefeuille sera hors ligne jusqu'à ce que la restauration soit terminée. Ceci écrasera votre base de données actuelle et vos paramètres.",
  "BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE": "Les archives de sauvegardes sont corrompues. Sélectionnez une autre sauvegarde pour une restauration.",
  "BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE": "Le lecteur de sauvegarde ne dispose pas d'un espace suffisant\n pour terminer.\n\n{requiredSpace} requis, {availableSpace} disponible.",
  "BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY": "L’emplacement de sauvegarde actuellement configuré n’existe pas. L’emplacement de sauvegarde est utilisé pour décompresser l’archive lorsqu’une sauvegarde est restaurée. Veuillez sélectionner un répertoire valide pour l’emplacement de sauvegarde.",
  "BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP": "Problème avec la sauvegarde. Pour plus d'informations, consultez le journal d'admin.",
  "BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE": "Problème avec la restauration. Pour plus d'informations, consultez le journal d'admin.",
  "BACKUP_RESTORE_LABEL": "Restaurer",
  "BACKUP_RESTORE_TITLE": "Sauvegarde/Restauration",
  "BACKUP_RETAIN_LABEL": "Conserver",
  "BACKUP_RETAIN_VALUE": "Conserver uniquement les {numBackups} sauvegardes les plus récentes",
  "BACKUP_SATURDAY_LABEL": "Samedi",
  "BACKUP_SCHEDULE_LABEL": "Planifier les sauvegardes",
  "BACKUP_SCHEDULE_VALUE": "le",
  "BACKUP_SUNDAY_LABEL": "Dimanche",
  "BACKUP_THURSDAY_LABEL": "Jeudi",
  "BACKUP_TUESDAY_LABEL": "Mardi",
  "BACKUP_WEDNESDAY_LABEL": "Mercredi",
  "BROWSE": "Parcourir",
  "BROWSE_FOLDERS_TITLE": "Parcourir les dossiers du serveur",
  "BROWSE_RECENT_FOLDERS_LABEL": "Dossiers récents",
  "BROWSE_REFRESH": "Synchroniser des éléments",
  "CALL_ATT_BUTTON_BUY_NOW": "Acheter maintenant",
  "CALL_ATT_BUTTON_SECONDARY": "Contacter le service des ventes pour un devis",
  "CALL_ATT_FADEL_BUTTON_MAIN": "Ventes de contact pour plus d'information",
  "CALL_ATT_FADEL_MAIN": "Assurez-vous de la bonne utilisation du contenu sous licence, des images aux vidéos et de tout ce qui se situe entre les deux. Le portefeuille se connecte sans difficulté au logiciel FADEL Rights Cloud pour que vous puissiez aisément comprendre les droits d’utilisation qui sont associés à vos éléments. Cela vous aide à résoudre les embouteillages de workflow et à réduire le risque d'infractions onéreuses aux droits d’auteur.",
  "CALL_ATT_FADEL_SUBTITLE": "Prenez connaissance de vos droits d’utilisateur",
  "CALL_ATT_FADEL_TITLE": "FADEL RIGHTS CLOUD",
  "CALL_ATT_ME_SUBTITLE": "Conversion et traitement de haut niveau",
  "CALL_ATT_ME_MAIN": "Est-ce que vous repoussez les limites de performance de votre serveur Portfolio? Grâce à Media Engine, évitez les baisses de rendement et augmentez la productivité globale en supprimant les goulots d’étranglement propres aux environnements de production actifs.\n\n\t• Augmente la capacité et le débit\n\t• Déverrouille des formats de sortie supplémentaires\n\t• Accélère la création des aperçus vidéo\n\t• Ajouter plusieurs Media Engines selon les besoins\n\t• Filigrane (nécessite NetPublish)",
  "CALL_ATT_ME_BUTTON_MAIN": "Obtenir Media Engine",
  "CALL_ATT_NP_SUBTITLE": "Portails libre-service pour un accès immédiat aux actifs",
  "CALL_ATT_NP_MAIN": "Vous en avez assez de ces demandes de dernière minute à chaque fois qu’une personne a besoin d’un actif ? Grâce à NetPublish, il est facile de publier des sites Internet en libre service qui permettent à tous les utilisateurs de trouver et télécharger les actifs dont ils besoin à partir de n’importe quel navigateur et périphérique.\n\n\t• Création de site d’un simple clic- aucun code HTML ou CSS\n\t• Conception interactive et compatible avec les portables\n\t• Contrôle souple de l’accès utilisateur\n\t• Désactiver automatiquement les sites\n\t• Définir la résolution, la taille et le format lors du téléchargement\n\t• Filigrane (nécessite Media Engine)\n\t• Rapport d’utilisation",
  "CALL_ATT_NP_BUTTON_MAIN": "Obtenir NetPublish",
  "CALL_ATT_REPORT_TITLE": "Création de rapports pour NetPublish",
  "CALL_ATT_REPORT_SUBTITLE": "Informations d’utilisation pertinentes",
  "CALL_ATT_REPORT_MAIN": "Vous voulez savoir quels sites sont les plus actifs, quels actifs sont utilisés et par qui ? Avec la création de rapports NetPublish, obtenez les informations dont vous avez besoin pour prendre les décisions éclairées sur l’utilisation de Portfolio au sein de votre organisation.\n\nRépartition de l’utilisation par :\n\t•Nom de site NetPublish\n\t• Nom d’utilisateur\n\t• ID et nom d’actif\n\t• Date et heure",
  "CALL_ATT_REPORT_BUTTON_MAIN": "Obtenir NetPublish",
  "CALL_ATT_SK_BUTTON_MAIN": "Essayer gratuitement",
  "CALL_ATT_SK_BUTTON_TRY_NOW": "http://extens.is/jzp6",
  "CALL_ATT_SK_MAIN": "Vous cherchez une façon d'accélérer votre processus pour affecter des mots-clés aux images ? Avec Portfolio Smart Keywords, vous pouvez automatiquement affecter des mots-clés « intelligents » à vos images d'un seul clic. Optimisé par Clarifai, une société innovante d'intelligence artificielle qui excelle dans les technologies de reconnaissance visuelle, une liste de mots-clés peut être fournie en quelques secondes.\n\n\t• Fournit une liste de Smart Keywords en quelques secondes\n\t• Économise du temps et des ressources en réduisant la saisie manuelle de mots-clés\n\t• Établit une taxonomie cohérente pour votre organisation\n\t• Facilite la recherche rapide de vos ressources numériques",
  "CALL_ATT_SK_SUBTITLE": "Automatisez votre association de mots-clés avec des images",
  "CALL_ATT_SK_TITLE": "Portfolio Smart Keywords",
  "CALL_ATT_SSO_SUBTITLE": "Expérience utilisateur transparente entre les plates-formes",
  "CALL_ATT_SSO_TITLE": "Single Sign-On",
  "CALL_ATT_SSO_MAIN": "Est-ce qu’une gestion simple de leurs informations de connexion pose des difficultés aux membres de votre organisation ? Généralement, les nouvelles solutions de gestion des comptes utilisateurs sont synonymes de frais supplémentaires pour votre organisation et les utilisateurs.\n\nHeureusement, Portfolio prend en charge Single Sign-On avec Active Directory. Grâce à Single Sign-On, les utilisateurs peuvent se connecter dans Portfolio automatiquement depuis votre site intranet et de bénéficier d’une expérience utilisateur totale.\n\n\t• Prend en charge Windows Server Active Directory\n\t• Améliore la sécurité globale\n\t• Simplifie la gestion des utilisateurs\n\t• Améliore l’expérience utilisateur",
  "CALL_ATT_SSO_BUTTON_MAIN": "Obtenir Single Sign-On",
  "CALL_ATT_URL_BUY_NOW": "https://secure.extensis.com/portfolio-options?lang=fr",
  "CALL_ATT_URL_CONTACT_SALES": "http://extensis.com/fr/portfolio/contact-me",
  "canEmbedMetadata": "Intégrer les métadonnées",
  "canImportMetadata": "Importer/Exporter des données",
  "canManageFieldLists": "Gérer les listes de champs publics",
  "canManagePublicGallery": "Gérer les présentations publiques",
  "canModifyFolderStructure": "Modifier les structures du dossier",
  "canMoveAssets": "Déplacer les ressources",
  "canPublishNetPublishSites": "Peut publier des sites NetPublish",
  "canSmartKeyword": "Accès à Smart Keyword",
  "CANCEL": "Annuler",
  "CATALOG": "Catalogue",
  "CATALOG_ADD_SELECTED_USERS_TO_CATALOG": "Autoriser l'adhésion",
  "CATALOG_BACKUP": "Sauvegarder le catalogue sélectionné",
  "CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS": "Changer les rôles",
  "CATALOG_CREATE": "Ajouter un nouveau catalogue",
  "CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG": "Les administrateurs de catalogue peuvent ajouter des dossiers AutoSync à partir du Client du bureau.",
  "CATALOG_CREATE_AUTOSYNC_FOLDER": "Créer un dossier AutoSync",
  "CATALOG_CREATE_CATALOG_TEMPLATE": "Modèle de catalogue",
  "CATALOG_TYPE_GENERAL": "Utilisation générale",
  "CATALOG_TYPE_SIMPLE": "Simple",
  "CATALOG_CREATE_DATABASES_LIST_LABEL": "Bases de données",
  "CATALOG_CREATE_ERROR_CREATING_FOLDERS": "Une erreur est survenue lors de la création du {folder} dossier.",
  "CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG": "Les dossiers par défaut pour AutoSync et les prévisualisations peuvent être configurés dans les paramètres généraux.",
  "CATALOG_CREATE_NAME": "Nom",
  "CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG": "Les prévisualisations peuvent être configurées dans les détails du catalogue.",
  "CATALOG_CREATE_PREVIEW_FOLDER": "Enregistrer les prévisualisations pour une prévisualisation plus rapide",
  "CATALOG_CREATE_SHOW_DATABASES": "Afficher les bases de données",
  "CATALOG_CREATE_USE_VERSIONING": "Utiliser le versionnage d'actifs",
  "CATALOG_DELETE": "Supprimer le catalogue",
  "CATALOG_DELETE_CONFIRM": "Voulez-vous supprimer le catalogue sélectionné ?",
  "CATALOG_DETAILS": "Détails du catalogue",
  "CATALOG_DETAILS_CHANGE_NAME_PROMPT": "Pour renommer ce catalogue, nous devons le mettre hors ligne temporairement ; voulez-vous continuer ?",
  "CATALOG_DETAILS_COLLATION": "Assemblage",
  "CATALOG_DETAILS_COLLATION_NA": "N/D",
  "CATALOG_DETAILS_CREATION_DATE": "Date de création",
  "CATALOG_DETAILS_DATABASE_TAB": "General",
  "CATALOG_DETAILS_FILETYPES_TAB": "Types de fichiers",
  "CATALOG_DETAILS_LAST_MODIFIED": "Date de la dernière modification",
  "CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS": "Utilisateurs connectés",
  "CATALOG_DETAILS_NUMBER_OF_RECORDS": "Enregistrements",
  "CATALOG_DETAILS_NUMBER_OF_USERS": "Membres",
  "CATALOG_DETAILS_SIZE_ON_DISK": "Taille sur le disque",
  "CATALOG_DETAILS_WARN_DISCONNECT_ADMIN": "L'utilisateur administrateur sera déconnecté. Continuer?",
  "CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION": "Verrouillé pour l'administration",
  "CATALOG_DETAILS_UNLOCK": "Déverrouiller",
  "CATALOG_EXPLANATION_VAULT_1": "Les catalogues d'archivage stockent les actifs dans un emplacement sécurisé.",
  "CATALOG_EXPLANATION_VAULT_2": "Les catalogues d’archivage prennent en charge le verrouillage, les différences de version, l’extraction et l’archivage.",
  "CATALOG_EXPLANATION_WF_1": "Les catalogues de surveillance de dossier suivent les actifs contenus dans votre système de fichiers.",
  "CATALOG_EXPLANATION_WF_2": "Les catalogues de surveillance de dossier prennent en charge AutoSync.",
  "CATALOG_FILES_TAB_TITLE": "Ingérer",
  "CATALOG_INGEST_DRAG_HINT_TEXT": "Pour ajouter des champs au formulaire de téléchargement, faites les glisser sur la liste des champs.",
  "CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL": "Champs pour le formulaire de téléchargement",
  "CATALOG_INGEST_FIELDS_LABEL": "Champs",
  "CATALOG_INGEST_FORM_HEADER_LABEL": "En-tête du formulaire",
  "CATALOG_INGEST_HEADER_HINT_TEXT": "L'en-tête du formulaire est optionnel et s'affiche en haut du formulaire.",
  "CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE": "Le nombre maximum de champs pouvant être ajoutés à un formulaire est de {maxFields}.",
  "CATALOG_INGEST_TAB_TITLE": "Gestion des Ajouts",
  "CATALOG_INGEST_USE_INGEST_LABEL": "Utiliser la gestion de téléchargement",
  "CATALOG_INGEST_REQUIRED_LABEL": "Obligatoire",
  "CATALOG_IS_CONNECTED": "Connecté",
  "CATALOG_IS_DEFAULT": "Par défaut",
  "CATALOG_MANAGE_USERS": "Gestion des adhésions au catalogue",
  "CATALOG_MANAGE_FIELDS": "Gérer des champs de catalogue",
  "CATALOG_MANAGE_TEMPLATES_MENU_LABEL": "Gérer les modèles de catalogue...",
  "CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE": "Gérer les modèles de catalogue personnalisés",
  "CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER": "Nom du modèle de catalogue",
  "CATALOG_MEMBER": "Membre",
  "CATALOG_NEW_CATALOG_DETAILS": "Détails sur le nouveau catalogue",
  "CATALOG_OFFLINE": "Hors ligne",
  "CATALOG_ONLINE": "En ligne",
  "CATALOG_OPTIONS_ALL_FILE_TYPES": "Cataloguer tous les types de fichiers",
  "CATALOG_OPTIONS_ONLY_FILE_TYPES": "Cataloguer uniquemente",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL": "Créer des mots clefs à partir du chemin d'accès",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME": "Nom de fichier",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT": "Dossier parent",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER": "Nom du serveur",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE": "Arborescence des dossiers",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME": "Volume",
  "CATALOG_OPTIONS_EXCLUSION_LABEL": "Exclusion de fichiers et dossiers",
  "CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION": "Enlever le ou les type(s) de fichiers sélectionné(s) ?",
  "CATALOG_TEMPLATES_TITLE": "Modèles de Catalogue",
  "endsWith": "Se termine par",
  "contains": "Contient",
  "startsWith": "Commence avec",
  "CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION": "Enlever la ou les exceptions sélectionnées?",
  "CATALOG_OPTIONS_TAB_TITLE": "Options de catalogage",
  "CATALOG_PREVIEWS_DEFAULT_LOCATION_IS": "L’emplacement par défaut est",
  "CATALOG_PREVIEWS_DIMENSIONS_LABEL": "Taille minimale 300 pixels, taille maximale 4000 pixels (plus grande dimension)",
  "CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES": "Générer des clips pour des fichiers audio/vidéo",
  "CATALOG_PREVIEWS_GENERATE_PREVIEWS": "Créer des aperçus",
  "CATALOG_PREVIEWS_FOLDER_LOCATION": "Enregistrer les prévisualisations et clips dans ce dossier",
  "CATALOG_PREVIEWS_LOCATION_WARNING_INFO": "L'emplacement doit être accessible au serveur.",
  "CATALOG_PREVIEWS_MAX_PIXELS": "Taille d'image maximale",
  "CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION": "Résolution vidéo maximale",
  "CATALOG_PREVIEWS_MINUTES": "minutes",
  "CATALOG_PREVIEWS_PIXELS": "pixels",
  "CATALOG_PREVIEWS_SHORT": "Aperçus",
  "CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION": "Limiter la durée à",
  "CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT": "Générer des clips peut prendre un certain temps de traitement.\nPour limiter le temps de traitement, choisissez une résolution et durée plus faible.",
  "CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG": "Révoquer l'adhésion",
  "CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION": "Supprimer l’utilisateur du catalogue ?\nLes éléments extraits des utilisateurs dans ce catalogue seront restaurés et rendus accessibles.",
  "CATALOG_SAVE_TEMPLATE": "Sauvegarder le modèle de catalogue",
  "CATALOG_SAVE_TEMPLATE_TITLE": "Sauvegarder le modèle de catalogue",
  "CATALOG_SAVE_TEMPLATE_DETAILS_TEXT": "Le modèle sauvegardé comprend : tous les champs, les mappages des métadonnées et les paramètres optionnels du catalogue.",
  "CATALOG_SELECT_MESSAGE": "Aucun catalogue sélectionné",
  "CATALOG_SET_AS_DEFAULT": "Définir le catalogue par défaut",
  "CATALOG_SK_DEFAULT_SETTINGS": "Réglages par défaut",
  "CATALOG_SK_CONFIDENCE_LEVEL_LABEL": "Niveau de confidentialité",
  "CATALOG_SK_DEFAULT_LABEL": "Recommandé : {recommended}",
  "CATALOG_SK_ENGINES_LABEL": "Moteurs de Smart Keywords",
  "CATALOG_SK_LANGUAGES_LABEL": "Langues pour le moteur général",
  "CATALOG_SK_NUM_KEYWORDS_LABEL": "Nombre de mots-clés",
  "CATALOG_SK_SETTINGS_LABEL": "Paramètres",
  "CATALOG_SK_TAB_TITLE": "Smart Keywords",
  "CATALOG_SK_USE_SK_LABEL": "Utiliser des Smart Keywords dans ce catalogue",
  "CATALOG_SK_KEYWORD_ON_CATALOG_LABEL": "Mots-clés intelligents nouveaux actifs catalogués",
  "CATALOG_STATUS": "État du catalogue",
  "CATALOG_STORAGE_TYPE_LABEL": "Type de stockage",
  "CATALOG_STORAGE_TYPE_WATCHFOLDERS": "Voir les dossiers",
  "CATALOG_STORAGE_TYPE_VAULT": "Archivage",
  "CATALOG_STORAGE_TYPE_S3": "S3",
  "CATALOG_TAKE_OFFLINE_SHORT": "Travailler hors ligne",
  "CATALOG_TAKE_ONLINE_SHORT": "Travailler en ligne",
  "CATALOG_TEMPLATE": "modèle",
  "CATALOG_TEMPLATE_NAME": "Nom du modèle",
  "CATALOG_TEMPLATE_REMOVE_CONFIRMATION": "Supprimer le modèle de catalogue sélectionné ?",
  "CATALOG_VIEW_DETAILS": "Afficher/Modifier les détails du catalogue",
  "CERT_CREATE_REQUEST": "Créer une demande de certificat",
  "CERT_DELETE_CONFIRMATION": "Voulez-vous vraiment supprimer les polices sélectionnées ? La suppression est irréversible.",
  "CERT_DOWNLOAD": "Télécharger",
  "CERT_EXPIRATION_DATE": "Date d’expiration",
  "CERT_FILE": "Fichier certificat",
  "CERT_FILE_INT_1": "Certificat intermédiaire 1",
  "CERT_FILE_INT_2": "Certificat intermédiaire 2",
  "CERT_FILE_PASSWORD": "Mot de passe du certificat",
  "CERT_FILE_PASSWORD_HELP": "Si votre certificat est protégé par un mot de passe, saisissez-le ici",
  "CERT_FILE_PROMPT": "Sélectionner...",
  "CERT_FILE_ROOT": "Certificat racine",
  "CERT_IMPORT": "Importer un certificat",
  "CERT_ISSUER": "Émetteur",
  "CERT_OWNER": "Propriétaire",
  "CERT_PENDING_REQUEST": "Demande de certificat en attente",
  "CERT_REQUEST_ALREADY_CREATED_WARNING": "Vous avez déjà créé une demande de certificat. Si vous continuez, la demande existante sera supprimée.",
  "CERT_IMPORT_SUCCEEDED": "Le certificat a été importé avec succès. Veuillez redémarrer le serveur Portfolio et les services d’administration Portfolio pour commencer à utiliser le certificat.",
  "CERT_IMPORT_FAILED_READING_PKCS12": "Le serveur n'a pas pu lire le certificat PKCS12. Vérifiez le mot de passe.",
  "CERT_IMPORT_FAILED_INTERMEDIATE1": "Le certificat intermédiaire 1 n’a pas pu être importé.",
  "CERT_IMPORT_FAILED_INTERMEDIATE2": "Le certificat intermédiaire 2 n’a pas pu être importé.",
  "CERT_IMPORT_FAILED_ROOT": "Le certificat racine n'a pas pu être importé.",
  "CERTIFICATE_FILE_FILTER": "Certificats (p7b, p7, cer, crt, pem, pfx, p12)",
  "CERTIFICATE_STATUS_INVALID": "Certificat non valide",
  "CERTIFICATE_STATUS_SELF_SIGNED": "Certificat non valide : Auto-signé",
  "CERTIFICATE_STATUS_EXPIRED": "Certificat expiré",
  "CERTIFICATE_STATUS_IMPORTED": "Certificat importé",
  "CERTS_TITLE": "Certificat SSL",
  "CHANGE": "Modifier",
  "CITY_OR_LOCALITY": "Ville ou localité",
  "CLEAR_BUTTON_LABEL": "Effacer",
  "COMMUNICATION_AT_INITILIZATION_ERROR": "Erreur de communication avec le serveur. Cette erreur est souvent causée par les données anciennes du cache du navigateur mais cela pourrait aussi signaler un problème venant du serveur. Veuillez contacter votre administrateur pour plus d'informations.",
  "CONFIGURE_DIRECTORY_SERVICE": "Configurer le service d'annuaire",
  "CONFIGURE_EMAIL_LINK": "Configurer les notifications par courriel…",
  "CONFIRM_DELETE_PDL": "Supprimer toutes les valeurs prédéfinies pour ce champ ?",
  "CONFIRM_DELETE_SERVICE": "Supprimer le service d'annuaire?\nLes utilisateurs importés de ce service resteront. Leurs mots de passe seront réinitialisés aux valeurs définies précédemment dans Portfolio (le cas échéant), ou seront désactivés.",
  "CONFIRM_TRUNCATE_VALUES": "La longueur maximale dépasse une ou plusieurs valeur prédéfinies ou par défaut pour ce champ. Raccourcir les valeurs ?",
  "CONNECTION_REFUSED_ERROR": "La connexion au service de répertoire a été refusée. Veuillez vérifier votre nom d'hôte et vos paramètres de port.",
  "CONTAINS": "contient",
  "CONTINUE": "Continuer",
  "CREATE": "Créer",
  "CREATE_A_CERTIFICATE_REQUEST": "Créer une demande de signature de certificat",
  "CREATE_CATALOG": "Créer une catalogue",
  "createContactSheet": "Créer un PDF",
  "CREATE_USER": "Créer un utilisateur",
  "CREATED_BY": "Créé par",
  "CREATE_MAPPING": "Créer un Mappage",
  "CREATE_USER_EXCLUSION_MAPPING": "Exclure l'Utilisateur",
  "CREATED_ON_DATE": "Date de création",
  "DATE_FORMAT": "DD-MM-YYYY",
  "DATE_FORMAT_ERROR": "Erreur de configuration : Mise en forme chaîne incorrecte.",
  "DATE_INVALID_CHAR_ERROR": "La date contient des caractères non valides.",
  "DATE_TIME_FORMAT": "DD-MM-YYYY L:NN A",
  "DATE_TIME_SECONDS_FORMAT": "DD-MM-YYYY L:NN:SS A",
  "DATE_WRONG_DAY_ERROR": "Saisir un jour valide pour le mois.",
  "DATE_WRONG_LENGTH_ERROR": "Saisir la date au format :",
  "DATE_WRONG_MONTH_ERROR": "Saisir un mois entre 1 et 12",
  "DATE_WRONG_YEAR_ERROR": "Saisir une année entre 0 et 9999",
  "DEFAULT_ACCESS_LEVEL": "role par défaut",
  "DEFAULT_CATALOG": "Catalogue par défaut",
  "DEFAULT_CATALOG_NONE": "Aucun",
  "DEFAULT_PORT_NON_SSL": "Port non SSL par défaut:",
  "DEFAULT_PORT_SSL": "Port SSL par défaut:",
  "DELETE": "Supprimer",
  "deleteAssetContents": "Supprimer les éléments d'origine",
  "deleteAssetFromCatalog": "Supprimer la ressource du catalogue",
  "DELETE_SOURCE": "Supprimer la Source",
  "DELETE_ALL_NESTED_VALUES_CONFIRMATION": "Supprimer toutes les valeurs? Ceci supprimera toutes les valeurs y compris les valeurs imbriquées.",
  "DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION": "Supprimer la valeur '{value}' ?\nIt Contient des valeurs imbriquées qui seront aussi supprimées.",
  "DELETE_NESTED_VALUE_CONFIRMATION": "Supprimer les valeurs sélectionnées? Elles comportent des valeurs imbriquées qui seront également supprimées.",
  "DELETE_WARNING_BOX_MSG": "Attention ! La suppression est irréversible!",
  "DELETE_WARNING_CATALOG_VAULT": "Tous les fichiers dans le catalogue seront détruits.",
  "DIAGNOSTICS_TITLE": "Diagnostics",
  "DIAGNOSTICS_NO_PROBLEMS": "Aucun problème trouvé",
  "DIAGNOSTIC_DATA_TITLE": "Envoyer le rapport de diagnostic à Extensis",
  "DIAGNOSTIC_DATA_ACCOUNT_NAME": "Nom de compte ou d’entreprise (Requis)",
  "DIAGNOSTIC_DATA_CONTACT_NAME": "Nom du contact",
  "DIAGNOSTIC_DATA_TS_TICKET_NUMBER": "Numéro de ticket d’assistance technique",
  "DIAGNOSTIC_DATA_SEND_REPORT_BUTTON": "Envoyer rapport",
  "DIAGNOSTIC_STATUS_ERROR": "Problème lors du chargement du rapport de diagnosticle {date}",
  "DIAGNOSTIC_STATUS_SENDING": "Envoi en cours...",
  "DIAGNOSTIC_STATUS_SUCCESS": "Envoi réussi du rapport de diagnostic à Extensis le {date}",
  "DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE": "Requête en cours. Cela peut prendre quelques minutes...",
  "DIRECTORY_SERVICE_CONNECT_ERROR": "Impossible de se connecter au service de répertoire. Veuillez vérifier le nom d'hôte et les paramètres de port.",
  "DIRECTORY_SERVICE_BROWSE_FILTER_LABEL": "Filtre",
  "DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL": "Active Directory pour utilisateurs et groupes",
  "DIRECTORY_SERVICE_CONFIG_TITLE": "Configuration des services d'annuaire",
  "DIRECTORY_SERVICES_TITLE": "Services d'annuaire",
  "DIRECTORY_SERVICE_SAVE_MAPPINGS": "Enregistrer et synchroniser",
  "DIRECTORY_SERVICE_REMOVE_MAPPING": "Supprimer le mappage",
  "DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL": "Importations d'utilisateurs de Portfolio",
  "DIRECTORY_SERVICE_MAPIINGS": "Éléments de l’annuaire pour les mappages de Portfolio",
  "DIRECTORY_SERVICE_MAPIINGS_TITLE": "Mappages",
  "DIRECTORY_SERVICE_NO_MAPPINGS_LABEL": "Aucun mappage.\n\nPour créer un mappage, sélectionnez un utilisateur ou un groupe sur la gauche, puis cliquez sur « Créer un mappage ».",
  "DIRECTORY_SERVICES": "Services d'annuaire",
  "DIRECTORY_USERS_CANNOT_BE_DELETED": "Les utilisateurs du service d'annuaire ne peuvent pas être supprimés !",
  "DISTRIBUTION_GROUPS": "Groupes de distribution",
  "DOWNLOAD_CERT_PROMPT": "Télécharger le fichier de demande de certificat ?",
  "DOWNLOAD_COMPLETE_STRING": "Fin du téléchargement.",
  "downloadPreviews": "Télécharger les aperçus",
  "EMAIL_ADDRESS": "Adresse email",
  "EMAIL_CONFIG_AUTH_PASSWORD": "Mot de passe",
  "EMAIL_CONFIG_AUTH_USERNAME": "Nom d'utilisateur",
  "EMAIL_CONFIG_ENABLED": "Activer les notifications par courriel",
  "EMAIL_CONFIG_FROM_ADDRESS": "Adresse de l'émetteur du courriel",
  "EMAIL_CONFIG_INVALID_GENERIC": "Configuration du serveur de messagerie non valide",
  "EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND": "Serveur de messagerie non trouvé",
  "EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED": "Échec de l'authentification du serveur de messagerie",
  "EMAIL_CONFIG_MESSAGE": "Tout utilisateur souhaitant recevoir des notifications doit disposer d'une adresse de courriel affectée dans le volet Utilisateurs.",
  "EMAIL_CONFIG_SERVER_ADDRESS": "Adresse du serveur SMTP",
  "EMAIL_CONFIG_SERVER_PORT": "Port serveur SMTP",
  "EMAIL_CONFIG_SUCCESS_MESSAGE": "Serveur SMTP validé",
  "EMAIL_CONFIG_USE_SSL_TLS": "Utiliser SSL / TLS",
  "EMAIL_CONFIG_USE_SMTP_AUTH": "Utiliser l'authentification SMTP",
  "EMAIL_CONFIG_VALIDATE": "Test de connexion",
  "EMAIL_CONFIG_VALIDATED": "Serveur de messagerie validé",
  "english": "Anglais",
  "ENTIRE_TREE_UNDER_SEARCH_BASE": "Arborescence entière sous la base de recherche",
  "EQUALS": "égal à",
  "esp.port.admin-web-app": "Port HTTP administrateur Portfolio",
  "esp.port.admin-web-app-ssl": "Port SSL administrateur Portfolio",
  "esp.port.http": "Port HTTP serveur Portfolio",
  "esp.port.ssl": "Port SSL serveur Portfolio",
  "EXPORT_MENU_STRING": "Exporter des valeurs",
  "FADEL_HOWTO": "Procédure de connexion à votre compte de FADEL :",
  "FALSE_LABEL": "Faux",
  "FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR": "Assurez-vous que le serveur d'administration est en cours d'exécution sur votre ordinateur local, avec le numéro de port inscrit sur la page des ports. Si ce n'est pas le cas, redémarrez le serveur et relancez l'application.",
  "FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS": "Cette opération ne peut pas être effectuée alors que la sauvegarde ou la restauration est en cours.",
  "FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE": "L'opération a échoué car le catalogue est en mode administrateur.",
  "FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME": "Un catalogue existe déjà sous ce nom.",
  "FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME": "Un utilisateur utilise déjà ce nom de compte.",
  "FAULT_MSG_DB_IN_USE": "L'opération n'a pu se terminer car un administrateur est en train d'utiliser le catalogue.",
  "FAULT_MSG_DELETE_ADMIN": "Vous ne pouvez pas supprimer le compte de l'administrateur.",
  "FAULT_MSG_DELETE_SELF": "Vous ne pouvez pas supprimer votre compte utilisateur.",
  "FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR": "Une erreur inattendue s'est produite lors de la suppression du modèle du catalogue",
  "FAULT_MSG_DUPE_NAME": "Un objet existe déjà sous ce nom. Veuillez utiliser un autre nom.",
  "FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS": "Un Media Engine existe déjà sous cette adresse et ce numéro de port.",
  "FAULT_MSG_ENTITY_VERSION_MISMATCH": " L'opération a échoué car les informations du client n'étaient plus à jour.",
  "FAULT_MSG_IDENT_SERVICE_CREATION_ERROR": "Assurez-vous que le serveur est en cours d'exécution sur votre ordinateur local, avec le numéro de port inscrit sur la page des ports. Si ce n'est pas le cas, redémarrez le serveur et relancez l'application.",
  "FAULT_MSG_INVALID_SESSION_ID": "Votre session a expiré. Vous devez vous connecter une nouvelle fois au serveur.",
  "FAULT_MSG_IS_NOT_LICENSED": "Le serveur n'est pas autorisé à effectuer cette opération.",
  "FAULT_MSG_LEGACY_21000": "L'opération a échoué suite à une erreur interne.",
  "FAULT_MSG_LOGGING_ERR_UPDATE": "Une erreur s'est produite lors de la mise à jour de la configuration de la journalisation",
  "FAULT_MSG_LOG_DIR_NOT_VALID": "Le répertoire du journal spécifié n'existe pas, n'est pas inscriptible, ou le chemin spécifié n'est pas un répertoire.",
  "FAULT_MSG_NO_DIRECTORY": "L’emplacement indiqué n’existe pas ou ne se trouve pas dans un répertoire.",
  "FAULT_MSG_NULL_DESCRIPTION": "Une erreur inattendue est survenue, mais aucune description n'est disponible.",
  "FAULT_MSG_NULL_FAULTEVENT": "Une erreur inattendue est survenue, mais aucun détail n'est disponible.",
  "FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES": "L'opération a échoué car vous ne disposez pas des autorisations nécessaires.",
  "FAULT_MSG_OPERATION_IS_INVALID": "L'opération n'était pas valide.",
  "FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR": "Une erreur inattendue s'est produite lors du renommage du modèle du catalogue",
  "FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR": "Une erreur inattendue s'est produite lors de la sauvegarde du modèle du catalogue",
  "FAULT_MSG_SERVER_NOT_RUNNING": "Le serveur n’est pas actif.",
  "FAULT_MSG_ENTERPRISE_NOT_LICENSED": "L'opération a échoué car le serveur n'a pas de licence pour le module Entreprise.",
  "FAULT_MSG_REMOVE_METADATA_DEF": "La suppression de la définition des métadonnées a échoué. Elle peut être utilisée par d’autres catalogues.",
  "FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT": "Le serveur a renvoyé une faute avec ce message : ",
  "FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE": "Le serveur a renvoyé une faute sans message d'erreur. ",
  "FAULT_MSG_UNHANDLED_UNKNOWN_FAULT": "Le serveur a renvoyé une faute à cause d'un type inconnu avec ce message :",
  "FAULT_MSG_UNKNOWN_SMTP_SERVER": "Impossible de se connecter au serveur de messagerie spécifié.",
  "FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING": "Cette opération a échoué car un des services n'avait pas l'état attendu.",
  "FAULT_MSG_INVALID_LOGINID_OR_PASSWORD": "Le nom d'utilisateur ou le mot de passe indiqué pour la base de données n’est pas valide.",
  "FAULT_MSG_BAD_DB_PORT": "Le port de la base de données indiqué n’est pas valide.",
  "FAULT_MSG_BAD_DB_HOST": "Le nom d’hôte de la base de données ou le port indiqué n’est pas valide.",
  "FIELD_ACTION_ADD": "Ajouter un nouveau champ personnalisé",
  "FIELD_ACTION_DELETE": "Supprimer le champ sélectionné",
  "FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES": "Espaces de noms XMP",
  "FIELD_ACTION_MANAGE_METADATA": "Gérer les métadonnées",
  "FIELD_ADD_EXTRACT_METADATA": "Ajouter le mappage de l’extrait",
  "FIELD_CATEGORY_ALL": "Tous Champs Actifs",
  "FIELD_CATEGORY_CUSTOM": "Champs personnalisés",
  "FIELD_CATEGORY_SYSTEM": "Champs système",
  "FIELD_CATEGORY_EXIF": "EXIF",
  "FIELD_CATEGORY_IPTC": "IPTC",
  "FIELD_CATEGORY_XMP": "XMP",
  "FIELD_CATEGORY_MOVIE": "Film",
  "FIELD_CATEGORY_OFFICE": "MS Office",
  "FIELD_CATEGORY_GEO": "GEO",
  "FIELD_CATEGORY_LABEL": "Catégorie de champ",
  "FIELD_CATEGORY_FONTSENSE": "Extensis Font Sense",
  "FIELD_DELETE_CONFIRM_MSG": "Voulez-vous supprimer le champ sélectionné ?",
  "FIELD_DISABLE_CONFIRM_MSG": "Voulez-vous désactiver le champ sélectionné?",
  "FIELD_ENABLE_ALL_CATEGORIES_LABEL": "Activer tout",
  "FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING": "Ajouter le mappage de l’extrait",
  "FIELD_FORM_LABEL_DEFAULT_VALUE": "Valeur par défaut",
  "FIELD_FORM_LABEL_DISABLED": "(Désactivé)",
  "FIELD_FORM_LABEL_EMBED": "Incorporer aux métadonnées",
  "FIELD_FORM_LABEL_EXTRACT": "Extraire des métadonnées",
  "FIELD_FORM_LABEL_FIELD_NAME": "Nom du champ",
  "FIELD_FORM_LABEL_FIELD_TYPE": "Type du champ",
  "FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES": "Autoriser plusieurs valeurs",
  "FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES": "Contient des valeurs prédéfinies",
  "FIELD_FORM_LABEL_HELP_TEXT": "Texte d’aide",
  "FIELD_FORM_LABEL_MAX": "Max : {max}",
  "FIELD_FORM_LABEL_MAX_LENGTH": "Longueur max.",
  "FIELD_FORM_LABEL_METADATA_TAG": "Nom de métadonnées",
  "FIELD_FORM_LABEL_METADATA_TYPE": "Type de métadonnées",
  "FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES": "Autoriser seulement les valeurs prédéfinies",
  "FIELD_FORM_LABEL_PRECISION": "Précision",
  "FIELD_FORM_LABEL_PRECISION_MAX": "Max",
  "FIELD_FORM_LABEL_PREDEFINED_VALUES": "Valeurs prédéfinies",
  "FIELD_FORM_LABEL_SHOW_TIME": "Afficher l’heure",
  "FIELD_FORM_LABEL_USE_METADATA": "Extraire et incorporer des Métadonnées",
  "FIELD_FORM_WARNING_DUPE_EMBEDS": "Avertissement : Plus d’un champ est intégré dans '{metadata}'",
  "FIELD_METADATA_DATA_TYPE_LABEL": "Type de données",
  "FIELD_METADATA_DEFINITION_IS_CUSTOM": "est personnalisé",
  "FIELD_METADATA_DEFINITIONS_TITLE": "Définitions des métadonnées",
  "FIELD_METADATA_DELETE_CONFIRM_MSG": "Confirmer : Supprimer la définition des métadonnées ?",
  "FIELD_METADATA_MULTIVALUED_TYPE_LABEL": "Type à plusieurs valeurs",
  "FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL": "N’accepte pas plusieurs valeurs",
  "FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL": "Classé",
  "FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL": "Non classé",
  "FIELD_METADATA_NAME_LABEL": "Nom",
  "FIELD_METADATA_NAMESPACE_LABEL": "Espace de nom",
  "FIELD_METADATA_NEW_NAMESPACE_TOOLTIP": "Ajouter un espace de nom XMP personnalisé...",
  "FIELD_METADATA_TAG_LABEL": "Balise",
  "FIELD_METADATA_TYPE_LABEL": "Type",
  "FIELD_MULTIPLE_EMBED_WARNING": "Plus d’un champ est intégré dans",
  "FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE": "Plusieurs champs sélectionnés",
  "FIELD_NAMESPACE_ABBREVIATION": "Abréviation",
  "FIELD_NAMESPACE_REMOVE_CONFIRMATION": "Supprimer l’espace de nom XMP personnalisé ?\n L’espace de nom est peut-être utilisé par des définitions de champ.",
  "FIELD_NAMESPACE_URI": "URI espace de nom",
  "FIELD_NEW_FIELD_NAME": "Nouveau champ",
  "FIELD_NEW_METADATA_TITLE": "Nouvelle définition de métadonnées",
  "FIELD_NEW_NAMESPACE_TITLE": "Nouvel espace de nom XMP personnalisé",
  "FIELD_NO_FIELD_SELECTED_MESSAGE": "Aucun champ sélectionné",
  "FIELD_PAGE_TITLE": "Gérer les champs pour le catalogue '{catalogName}'",
  "FIELD_REVERT_CONFIRM_MSG": "Confirmer : Renverser le champ ?",
  "FIELD_TYPE_BLOB": "Blob",
  "FIELD_TYPE_BOOLEAN": "Booléen",
  "FIELD_TYPE_DATETIME": "Date/Heure",
  "FIELD_TYPE_DECIMAL": "Décimal",
  "FIELD_TYPE_LANG_ALT": "Lang Alt",
  "FIELD_TYPE_NUMBER": "Nombre",
  "FIELD_TYPE_PICTURE": "Image",
  "FIELD_TYPE_STRING": "Chaîne",
  "FIELD_TYPE_STRUCTURE": "Structure",
  "FIELD_TYPE_TEXTBLOCK": "Bloc de texte",
  "FIELD_TYPE_UNKNOWN": "Inconnu",
  "FIELD_TYPE_URL": "URL",
  "FILE_IO_ERROR_MSG": "Une erreur s'est produite lors de l'ajout du fichier au serveur.",
  "FILE_TYPES_SECTION_TITLE": "Types de fichiers",
  "FILE_TYPES_ERROR_NAME_EXISTS": "Le nom « {name} » correspond au nom d’un type de fichier existant.",
  "FILE_TYPES_LABEL_RESTORE_DEFAULTS": "Réinitialiser les valeurs par défauts",
  "FILE_TYPES_PROMPT_DISCARD_CHANGES": "Ignorer les modifications en attente ?",
  "FILE_TYPES_PROMPT_RESTORE_DEFAULTS": "Réinitialiser tous les types de fichiers à leurs valeurs par défaut ?",
  "FILE_TYPES_ADD_FILE_TYPE": "Ajouter le type de fichier",
  "FILE_TYPES_UPDATE_FILE_TYPE": "Mettre à jour le type de fichier",
  "FILE_TYPES_EXTENSIONS": "Extensions",
  "FILE_WRONG_TYPE_ERROR_MSG": "Ce type de fichier n'est pas pris en charge.\nSélectionnez un fichier jpeg, gif ou png.",
  "FOLDER_PATH_AUTOSYNC_FILES_STRING": "Fichiers",
  "FOLDER_PATH_ALREADY_EXIST_AS_FILE": "Un fichier portant ce nom existe déjà.",
  "FOLDER_PATH_DOES_NOT_EXIST": "Le chemin d’accès n’existe pas.",
  "FOLDER_PATH_ERROR": "Erreur",
  "FOLDER_PATH_NOT_VERIFIED": "Le chemin d’accès au dossier n’a pas été vérifié.",
  "FOLDER_PATH_PATH": "Chemin d’accès",
  "FOLDER_PATH_OPERATION_INVALID": "Une opération non valide",
  "FOLDER_PATH_SUCCESS": "Réussite",
  "FOLDER_PATH_TYPE_AUTOSYNC": "autosync",
  "FOLDER_PATH_TYPE_PREVIEW": "prévisualisation",
  "FOLDER_PATH_UNKNOWN_FAULT": "Une faute inconnue",
  "french": "Français",
  "FULL_NAME": "Nom complet",
  "FULLY_QUALIFIED_DOMAIN_NAME": "Nom de domaine pleinement qualifié",
  "german": "Allemand",
  "DATA_COLLECTION_HELP_URL": "https://help.extensis.com/hc/fr/articles/1260804371029",
  "DATA_COLLECTION_RTI_OPT_OUT_LABEL": "Je suis d’accord pour partager des données d’utilisation sur l’application.",
  "DATA_COLLECTION_RTI_OPT_OUT_TEXT": "Aidez-nous à fournir les meilleures solutions en partageant l'utilisation de l'application avec nous.\n\nEn acceptant, vous nous aiderez à rassembler des informations importantes qui vont nous guider afin d’améliorer la qualité et les caractéristiques futures. Les informations rassemblées nous aident à comprendre vos besoins.\n\nVous pouvez toujours changer d’avis à tout moment et interrompre le partage des informations.\n\nPour plus d’informations sur la manière d’utiliser vos informations et vous désabonner dans le futur, veuillez consulter notre page d’aide: ",
  "DATA_COLLECTION_TITLE": "Analytique",
  "GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL": "Créer des dossiers AutoSync pour les nouveaux catalogues dans ce dossier",
  "GLOBAL_SETTINGS_BACKGROUND_COLOR": "Couleur d’arrière-plan",
  "GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP": "Couleur d'arrière-plan de l'écran de connexion.",
  "GLOBAL_SETTINGS_CATALOG_DEFAULTS": "Valeurs par défaut du catalogue",
  "GLOBAL_SETTINGS_CHOOSE_FILE": "Choisir un fichier",
  "GLOBAL_SETTINGS_CUSTOM_IMAGE": "Image personnalisée",
  "GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT": "La taille approximative doit être de 2400x1350 pixels.",
  "GLOBAL_SETTINGS_CUSTOM_TITLE": "Titre personnalisé",
  "GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP": "Titre qui apparaît sur l'onglet ou le signet du navigateur.",
  "GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN": "Écran de connexion personnalisé",
  "GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL": "role par défaut",
  "GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN": "Écran de connexion par défaut",
  "GLOBAL_SETTINGS_EMAIL_CONFIGURATION": "Notifications par courriel",
  "GLOBAL_SETTINGS_FADEL": "FADEL Rights Cloud",
  "GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG": "L’emplacement des dossiers AutoSync et de prévisualisation doit être accessible au serveur.",
  "GLOBAL_SETTINGS_IMAGE_URL": "Lien",
  "GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP": "L'URL sera lancée dans une autre fenêtre du navigateur si vous cliquez sur l'image.",
  "GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG": "Pour apporter des modifications, démarrez le serveur ou vérifiez si une licence de serveur est arrivée à expiration.",
  "GLOBAL_SETTINGS_PREVIEW_PATH_LABEL": "Enregistrer les prévisualisations pour les nouveaux catalogues dans ce dossier",
  "GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS": "Emplacements des données du serveur",
  "GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION": "Personnalisation de procédure de connexion de Portfolio",
  "GLOBAL_SETTINGS_SSO_CREDENTIALS": "Informations d’identification pour l’authentification unique",
  "GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP": "Saisir le compte de l’utilisateur associé au service Portfolio Server avec l’authentification Kerberos.",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL": "Dossier de travail temporaire:",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG": "Le dossier de travail sera modifié lors du prochain démarrage du serveur. Le nouveau dossier se trouvera à l’emplacement suivant : ",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG": "Vous devez redémarrer le serveur pour que cette modification prenne effet.",
  "GLOBAL_SETTINGS_VAULT_CONFIGURATION": "Configuration de Portfolio Vault",
  "GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL": "Dossier d'archivage du portefeuille :",
  "SERVER_DATA_DEFAULT_VAULT_LOCATION_IS": "Emplacement par défaut de l’archivage du portefeuille :",
  "GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE": "Pour modifier ce dossier, vous devez d'abord fermer le serveur Portfolio.",
  "GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE": "Avant de déplacer Portfolio Vault, veuillez arrêter le serveur.",
  "HELP_URL": "https://helpdocs.extensis.com/fr/portfolio/administration/{version}/index.htm",
  "HELP_URL_FADEL": "http://helpdocs.extensis.com/portfolio/{version}/administration/fr/Content/03_Catalogs/05_FADEL.htm",
  "HOSTNAME": "Nom d'hôte",
  "IDENTITY_SERVICE_DEFAULT_ROLE_STRING": "(par défaut)",
  "IDENTITY_SERVICE_SUCCESSFUL_CREATION": "Connexion au service de répertoire réussie. Configuration enregistrée.",
  "IMAGE_FILE_FILTER": "Images (jpg, gif, png)",
  "IMPORT_LDAP": "Importer des utilisateurs à partir du serveur LDAP/AD",
  "IMPORT_LDAP_SPECIFY_SERVER": "Spécifier le serveur LDAP/AD ",
  "IMPORT_MENU_STRING": "Importer des valeurs",
  "IMPORT_SOURCE": "Importer la source",
  "INVALID_DN_SYNTAX_ERROR": "Impossible de se connecter au service de répertoire en raison d'une erreur de syntaxe DN. Veuillez vérifier le nom d'utilisateur.",
  "japanese": "Japonais",
  "LAST_CERTIFICATE_REQUEST_LABEL": "Dernière demande de certificat",
  "LAST_MODIFIED_BY": "Dernière modification par",
  "LAST_MODIFIED_DATE": "Date de la dernière modification",
  "LDAP_ADDRESS": "Adresse du serveur LDAP/AD",
  "LDAP_BIND_USERNAME": "Nom d'utilisateur pour la liaison LDAP",
  "LDAP_SYNC_NOTIFICATION": "Le serveur a reçu la demande de synchronisation.",
  "LIC_ACTIVATE": "Activer Portfolio (identifiants requis)",
  "LIC_ADD_MESSAGE": "Copiez et collez les licences ou saisissez-les individuellement sur chaque ligne.",
  "LIC_ADD_SN": "Ajouter une nouvelle licence",
  "LIC_ADD_SN_SHORT": "Ajouter licences",
  "LIC_ASSET_CAP_DISPLAY": "Actifs",
  "LIC_CLICK_TO_ACTIVATE": "Cliquez pour activer Portfolio Server",
  "LIC_CLICK_TO_UPGRADE": "Cliquez pour mettre à niveau Portfolio Server",
  "LIC_CLICK_TO_USE": "Cliquez pour utiliser Portfolio pendant une durée limitée",
  "LIC_DAYS_REMAINING": "({days} jours restants)",
  "LIC_DEMO_PERIOD": "Période d’évaluation",
  "LIC_ERROR_MSG": "Numéro de série, veuillez recommencer. Si le problème persiste, vérifiez le journal de votre serveur ou contactez votre administrateur.",
  "LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG": "Impossible d’ajouter le numéro de série à Portfolio Studio.",
  "LIC_MAINTENANCE_END_DATE": "Date de fin de maintenance / abonnement",
  "LIC_SEAT_DISPLAY": "Sièges utilisateur",
  "LIC_TRIAL": "Tester Portfolio (numéro de série requis)",
  "LITE_CANNOT_CREATE_FDB_CATALOG": "La licence de votre Portfolio ne vous autorise pas à plusieurs catalogues. Veuillez envisager de mettre à jour votre licence de Portfolio pour accomplir cette action.",
  "LITE_CANNOT_SERVE_FDB_CATALOG": "Votre licence Portfolio Server ne permet pas de mettre en ligne d'autres catalogues.",
  "LITE_THIS_FEATURE_NOT_SUPPORTED": "Votre licence Portfolio Server ne prend pas en charge cette action.",
  "LOGGING_CONFIGURATION": "Configuration de la journalisation",
  "LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE": "Pour modifier l’emplacement du journal, arrêtez d’abord le serveur Portfolio.",
  "LOGGING_DEFAULT_LOCATION_MSG": "L’emplacement par défaut du journal est",
  "LOGGING_DIR_MUST_EXIST": "REMARQUE : Afin de modifier correctement le répertoire du journal, le nouveau répertoire spécifié doit déjà exister et être inscriptible par l'utilisateur sous lequel la version de Portfolio Server s'exécute.",
  "LOGGING_LOG_DIR": "Répertoire du journal :",
  "LOGGING_LOG_LEVEL": "Niveau de journalisation",
  "LOGGING_NUM_LOGS_TO_RETAIN": "Nombre de journaux à conserver",
  "LOGIN": "Connexion",
  "MAPPING_HEADER": "Mappage des utilisateurs/groupes vers Portfolio",
  "MAPPINGS_HAVE_BEEN_MODIFIED_ALERT": "Les mappages ont été modifiés. Voulez-vous les enregistrer ?",
  "MEDIA_ENGINE_NOT_OPERATIONAL": "Le moteur média n'était pas accessible.",
  "MEDIA_ENGINE_OPERATIONAL": "Le moteur de médias est opérationnel.",
  "MEDIA_ENGINES_ACTION_ADD": "Ajouter un nouveau Media Engine",
  "MEDIA_ENGINES_ACTION_DELETE": "Supprimer Media Engine",
  "MEDIA_ENGINES_ACTION_EDIT": "Afficher/modifier les détails de Media Engine",
  "MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE": "Impossible d'ajouter un autre  moteur média actif car le serveur utilise déjà actuellement le nombre maximum de moteurs média autorisés par votre licence Portfolio Media Engine.",
  "MEDIA_ENGINES_CANT_ADD_NO_LICENSES": "Vous ne pouvez pas ajouter de Media Engine car le serveur ne dispose par de licences Portfolio Media Engine.",
  "MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER": "Vous ne pouvez pas supprimer le Media Engine  intégré.",
  "MEDIA_ENGINES_COLUMN_ACTIVE": "Actif",
  "MEDIA_ENGINES_COLUMN_ADDRESS": "Adresse",
  "MEDIA_ENGINES_COLUMN_PORT": "Port",
  "MEDIA_ENGINES_COLUMN_TEST": "Tester",
  "MEDIA_ENGINES_CONFIRM_DELETE": "Voulez-vous supprimer le moteur média sélectionné ?",
  "MEDIA_ENGINES_EDIT_DETAILS_HEADER": "Détails de Media Engine",
  "MEDIA_ENGINES_LICENSES_LABEL": "Sièges Media Engine disponibles pour l'activation",
  "MEDIA_ENGINES_NEW_DETAILS_HEADER": "Détails du nouveau Media Engine",
  "MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE": "Aucun Media Engine n'est activé. Vous devriez activer un Media Engine avant que les clients ne doivent utiliser les services de Portfolio Media.",
  "MOBILE": "Mobile",
  "MOBILE_ENABLED": "Activer le téléchargement mobile",
  "MOBILE_FOLDER_VERBIAGE": "Enregistrer les téléchargements mobiles dans ce dossier :",
  "MOBILE_CREATE_CATALOG_VERBIAGE": "Créer un nouveau catalogue « Téléchargements mobiles » pour surveiller automatiquement ce dossier (recommandé)",
  "MOBILE_CATALOG_NAME": "Téléchargements mobiles",
  "modifyAssetContents": "Vérifiez les biens",
  "modifyAssetProperties": "Mettre à jour les champs de ressource",
  "MODIFY_LDAP": "Modifier demande LDAP",
  "NAME": "Nom",
  "NAME_TOO_LONG_ERROR": "Le nom ne doit pas dépasser 256 caractères",
  "NAV_ABOUT": "À propos de",
  "NAV_ACCESS_LEVELS": "Rôles",
  "NAV_AUTOSYNC": "Synchronisation automatique",
  "NAV_BACKUPS": "Sauvegarde/Restauration",
  "NAV_CATALOGS": "Catalogues",
  "NAV_GLOBAL_SETTINGS": "Paramètres généraux",
  "NAV_HELP": "Aide",
  "NAV_LICENSES": "Licences",
  "NAV_LOGOUT": "Déconnexion",
  "NAV_MEDIA_ENGINES": "Media Engines",
  "NAV_NETPUBLISH_SETTINGS": "NetPublish",
  "NAV_PORTS": "Ports",
  "NAV_REPORTING": "Rapports",
  "NAV_SETTINGS": "Paramètres",
  "NAV_STATUS": "État",
  "NAV_USERS": "Utilisateurs",
  "NP_SITES": "Sites NetPublish",
  "NP_SITE_DELETE_LABEL": "Supprimer le site",
  "NP_SITE_ENABLED_LABEL": "Site activé",
  "NO_CATALOGS": "Aucun",
  "NO_CATALOGS_EXIST": "Aucun catalogue existant.\n\nCliquez sur le bouton + pour créer un catalogue.",
  "NO_FILE_SELECTED": "Aucun fichier sélectionné",
  "NO_SITES_EXIST_1": "Pas de sites NetPublish.",
  "NO_SITES_EXIST_2": "Utiliser l’option Publier dans Portfolio pour créer et publier des sites.",
  "VaultFolderNotFound": "Dossier Portfolio Vault introuvable à l’emplacement {path}.",
  "NO_VAULT_FOLDER": "Dossier Portfolio Vault introuvable à l’emplacement {path}.  Veuillez vérifier l’emplacement du dossier dans votre système de fichiers, et dans la page Paramètres globaux -> Données du serveur de cette application.",
  "NOTES": "Remarques",
  "NOTIFICATION_FAILURE_ADD": "Erreur lors de l’ajout.",
  "NOTIFICATION_SUCCESS_UPDATE": "Mise à jour réussie",
  "NOTIFICATION_FAILURE_UPDATE": "La mise à jour à échoué",
  "NP_DELETE_SITE_CONFIRMATION": "Voulez-vous supprimer définitivement le site ?",
  "NP_SOURCE": "Source",
  "NUMBER_DECIMAL_POINT_COUNT_ERROR": "Le séparateur de décimal ne peut apparaitre qu'une fois.",
  "NUMBER_EXCEEDS_MAX_ERROR": "Le nombre saisi est trop grand.",
  "NUMBER_INTEGER_ERROR": "Le nombre doit être un entier.",
  "NUMBER_INVALID_CHAR_ERROR": "La saisie contient des caractères non valides.",
  "NUMBER_INVALID_FORMAT_CHARS_ERROR": "Un des paramètres de mise en forme n’est pas valide.",
  "NUMBER_LOWER_THAN_MIN_ERROR": "La quantité saisie est trop petite.",
  "NUMBER_NEGATIVE_ERROR": "La quantité ne doit pas être négative.",
  "NUMBER_PRECISION_ERROR": "La quantité saisie contient trop de chiffres après la décimale.",
  "NUMBER_SEPARATION_ERROR": "Le séparateur des milliers doivent être suivis de trois chiffres.",
  "OK": "OK",
  "ON_DATE": "le",
  "OPEN_DIRECTORY": "Open Directory",
  "OPEN_DIRECTORY_GROUPS": "Groupes",
  "ORGANIZATION_NAME": "Nom de l’organisation",
  "ORGANIZATIONAL_UNIT": "Unité organisationnelle",
  "PASSWORD": "Mot de passe",
  "PASSWORD_CONFIRM": "Confirmer le mot de passe",
  "PASSWORD_TOO_LONG_ERROR": "Le mot de passe ne doit pas dépasser 256 caractères",
  "PORT": "Port",
  "PORT_VALUE_TOO_HIGH_ERROR": "La valeur du port doit être inférieure à 65536.",
  "PortfolioAssetCap": "Portfolio Asset Cap",
  "PortfolioAPI": "Portfolio API",
  "PortfolioDemo": "Demo",
  "PortfolioDirServices": "Portfolio Directory Services",
  "PortfolioServer": "Portfolio Server",
  "PortfolioStudio": "Portfolio Studio Edition",
  "PortfolioProfessional": "Portfolio Professional Edition",
  "PortfolioEnterprise": "Portfolio Enterprise Edition",
  "PortfolioMediaEngine": "Portfolio Media Engine",
  "NetPublish": "Portfolio NetPublish",
  "PortfolioMobile": "Portfolio Flow",
  "PortfolioSmartKeywords": "Portfolio Smart Keywords",
  "PortfolioUserConnection": "Connexion utilisateur Portfolio",
  "PortfolioSingleSignOn": "Authentification unique (SSO)",
  "PORT_TITLE": "Ports",
  "PORT_DEFAULT": "Par défaut :",
  "PORT_CURRENT_VALUE": "Valeur actuelle",
  "PORT_ERROR_MSG_BAD_PORT_VALUE": "La nouvelle valeur de port doit être un nombre entre 1 et 65 535.",
  "PORT_ERROR_MSG_CONFLICT": "Vous ne pouvez pas mettre à jour les valeurs de port car une ou plusieurs des nouvelles valeurs sont actuellement utilisées sur le serveur.",
  "PORT_FIND_PORT": "Trouver un port",
  "PORT_NAME": "Nom",
  "PORT_NEW_VALUE": "Nouvelle valeur",
  "PORT_RESTART_NOTICE": "Remarque : les mises à jour du port ne prennent effet qu'après le redémarrage du serveur.",
  "PORT_RESTART_SERVER": "Redémarrer le serveur",
  "PORT_UPDATE_PORTS": "Mettre à jour les ports",
  "PORT_WARNING_ADMIN_RESTART": "Le port d'administration a été modifié. Le navigateur sera redirigé vers le nouvel emplacement dans {numSecs} secondes.",
  "PREVIEW_MAX_VIDEO_RESOLUTION_360": "360p",
  "PREVIEW_MAX_VIDEO_RESOLUTION_480": "480p",
  "PREVIEW_MAX_VIDEO_RESOLUTION_540": "540p HD",
  "PREVIEW_MAX_VIDEO_RESOLUTION_720": "720p HD",
  "PREVIEW_MAX_VIDEO_RESOLUTION_1080": "1080p HD",
  "PROMPT_ARE_YOU_SURE": "Êtes-vous sûr(e) ?",
  "PROMPT_COULD_NOT_CREATE_FOLDER": "Impossible de créer ce dossier. Veuillez entrer un autre chemin.",
  "PROMPT_COULD_NOT_CREATE_FOLDERS": "Saisissez un autre chemin d’accès au dossier, car il est impossible de créer les chemins d’accès suivants :",
  "PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT": "Impossible de créer ce dossier car un fichier existe déjà sous ce nom. Veuillez entrer un autre chemin.",
  "PROMPT_CREATE_THAT_FOLDER": "Ce dossier n'existe pas. Voulez-vous le créer ?",
  "PROMPT_CREATE_THESE_FOLDERS": "Ces dossiers n’existent pas. Voulez-vous les créer ?",
  "PROMPT_DELETE_LICENSE_CONFIRM": "Voulez-vous supprimer la licence sélectionnée?",
  "QUERY": "Requête",
  "REMOVE": "Supprimer",
  "REMOVE_DIRECTORY_SERVICE": "Retirer le service d'annuaire",
  "REPLACE_USER_MAPPING_CONFIRMATION": "Un mappage d'utilisateur régulier existe déjà pour cet utilisateur. Voulez-vous le remplacer par un mappage d'utilisateur exclus?",
  "REPLACE_USER_EXCLUSION_CONFIRMATION": "Un mappage d'utilisateur exclus existe déjà pour cet utilisateur. Voulez-vous le remplacer par un mappage d'utilisateur régulier?",
  "REQUIRED_FIELD_ERROR": "Ce champ est obligatoire",
  "REVERT": "Rétablir",
  "REVERT_CHANGES": "Rétablir les Modifications",
  "ROLES_CREATE_ROLE_TITLE": "Créer le Rôle",
  "ROLES_DELETE_CONFIRM": "Désirez-vous supprimer le rôle sélectionné?\nLes utilisateurs avec ce rôle seront reclassés au niveau inférieur de Lecteur.",
  "ROLE_FOR_IMPORT": "Rôle pour l’importation",
  "ROLES_PERMISSIONS": "Autorisations",
  "ROLES_PERMISSION_ENABLED_HEADER": "Activé",
  "ROLES_PERMISSION_NAME_HEADER": "Opération",
  "SAVE": "Enregistrer",
  "SAVE_MAPPING": "Enregistrer le Mappage",
  "saveOutputSetting": "Gérer les prédéfinitions de conversion et créer un PDF",
  "SEARCH": "Rechercher",
  "SEARCH_BASE": "Base de Recherche",
  "SEARCH_RESULTS": "Résultats de recherche",
  "SECURITY_GROUPS": "Groupes de sécurité",
  "SELECT": "Sélectionner",
  "SEND_DIAGNOSTIC_DATA": "Envoyer le rapport de diagnostic à Extensis",
  "SERVER_DATA_DEFAULT_WORK_LOCATION_IS": "Emplacement du travail par défaut: ",
  "SERVER_RESTART_REQUIRED": "Le serveur doit être redémarré pour que les modifications soient prises en compte.",
  "SERVER_STATE_ERROR": "Erreur : Voir le journal de l'administrateur pour plus de détails",
  "SERVER_STATE_STARTED": "Déroulement",
  "SERVER_STATE_STARTING": "Démarrage",
  "SERVER_STATE_STOPPED": "Arrêté",
  "SERVER_STATE_STOPPING": "Arrêt",
  "SERVER_STATE_UNKNOWN": "Inconnu",
  "SERVICE_BROWSER": "Navigateur de services",
  "SK_ENGINE_APPAREL": "Habillement",
  "SK_ENGINE_ART_STYLE": "Style d'art",
  "SK_ENGINE_ART_SUBJECT": "Sujet d'art",
  "SK_ENGINE_ART_MOVEMENT": "Mouvement artistique",
  "SK_ENGINE_CELEBRITIES": "Célébrités",
  "SK_ENGINE_FOOD": "Nourriture",
  "SK_ENGINE_GENERAL": "Généralités.",
  "SK_ENGINE_LOGO": "Logo",
  "SK_ENGINE_MODERATION": "Modération",
  "SK_ENGINE_NSFW": "NSFW",
  "SK_ENGINE_TRAVEL": "Voyage",
  "SK_ENGINE_WEDDINGS": "Mariages",
  "SSL_HANDSHAKE_ERROR": "L'établissement de liaison SSL a échoué ; veuillez vérifier que les paramètres de port et SSL sont corrects.",
  "STARTS_WITH": "commence par",
  "STATE_OR_PROVINCE": "État ou province",
  "STATUS": "État",
  "STATUS_ADMIN_LOG": "Journal de l'administrateur",
  "STATUS_API_VERSION_LABEL": "API",
  "STATUS_API_STATE_LICENSED": "Sous licence",
  "STATUS_API_STATE_UNLICENSED": "Sans licence",
  "STATUS_CLEAR_ADMIN_LOG": "Effacer le journal de l'administrateur",
  "STATUS_CONNECTED_USERS": "Utilisateurs connectés",
  "STATUS_MAX_ALLOWED_CONNECTIONS": "Nombre maximum de connexions",
  "STATUS_MEDIA_ENGINE_VERSION_LABEL": "Media Engine",
  "STATUS_MEDIA_ENGINES_ACTIVE": "Actif",
  "STATUS_MEDIA_ENGINES_LABEL": "Media Engines",
  "STATUS_RESTART_SERVER": "Redémarrer Portfolio",
  "STATUS_SEAT_USAGE": "Utilisation des postes de travail",
  "STATUS_SERVER_STATE": "Etat de Portfolio",
  "STATUS_SERVER_VERSION_LABEL": "Portfolio",
  "STATUS_START_SERVER": "Démarrer Portfolio",
  "STATUS_STOP_SERVER": "Arrêter Portfolio",
  "STATUS_PROBLEMS_DETECTED": "Problèmes détectés :",
  "STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM": "L’espace restant du disque de démarrage est inférieur à {minSpace} GO.",
  "STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS": "La mémoire système est {value}Go, ce qui est inférieur à la configuration minimale requise de {minGB}Go.",
  "STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE": "La mémoire système calculée par portefeuille est {value}Go, ce qui peut être inexact.",
  "STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST": "Le dossier de travail n’existe pas ou est inaccessible.",
  "STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE": "Le serveur Portfolio ne peut pas écrire dans le dossier de travail.",
  "STATUS_MSG_WORK_FOLDER_NOT_READABLE": "Le serveur Portfolio ne peut pas lire dans le dossier de travail.",
  "STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE": "Le serveur Portfolio ne peut créer de liens symboliques (symlinks) dans le dossier de travail.",
  "STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW": "L’espace restant du disque du dossier de travail est inférieur à {minSpace} GO.",
  "STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS": "Impossible d’obtenir le statut du dossier de travail.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED": "Le statut de l’index Elasticsearch {index} est rouge.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS": "L’index Elasticsearch {index} comporte des shards non initialisés.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE": "Certains shards sont actifs pour l’index Elasticsearch {index}.",
  "STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS": "Impossible de récupérer le statut d’Elasticsearch.",
  "STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER": "Impossible de récupérer des erreurs du serveur Portfolio.",
  "STATUS_MSG_STARTUP_FAILED": "Le démarrage a échoué",
  "STATUS_MSG_CANT_GET_SERVER_HEALTH": "Impossible de mettre à jour l’intégrité du serveur.",
  "STATUS_MSG_NATIVE_AGENT_NOT_RUNNING": "Le composant agent natif du serveur n’est pas en cours d’exécution.",
  "SUBJECT_ALTERNATIVE_NAMES": "Autres noms de sujet",
  "SUBMIT": "Soumettre",
  "swedish": "Suédois",
  "SYNC_DAILY": "Synchroniser quotidiennement",
  "synchronizeAutoSyncFolder": "Synchroniser les dossiers Autosync",
  "SYNCHRONIZE_NOW": "Synchroniser maintenant",
  "TARGET_CATALOG": "Catalogue cible",
  "THIS_LOCALE": "fr",
  "TRUE_LABEL": "Vrai",
  "TOKEN": "Jeton",
  "TOTAL_ASSETS": "Total des actifs",
  "TWO_LETTER_COUNTRY_CODE": "Code pays à deux lettres",
  "TYPE": "Type",
  "UNABLE_CONNECT_LDAP": "Connexion impossible au serveur LDAP/AD.",
  "UNABLE_CONNECT_SERVER": " Connexion impossible au serveur.",
  "UNKNOWN_HOST_ERROR": "Impossible de se connecter au service de répertoire en raison d'une exception d'hôte inconnu. Veuillez vérifier le nom d'hôte.",
  "UNKNOWN_LDAP_USER_ERROR": "Aucun utilisateur n'a été trouvé dans le service d'identité avec le nom d'utilisateur « {accountName} ».",
  "useCustomPresets": "Utiliser les préréglages de conversion",
  "USE_SSL": "Utiliser SSL",
  "USER_ACCOUNT": "Compte",
  "USER_CREATE": "Ajouter un nouvel utilisateur",
  "USER_DELETE": "Supprimer les utilisateurs",
  "USER_DELETE_CONFIRM": "Supprimer les utilisateurs sélectionnés ?",
  "USER_DELETE__DELETE_PRIVATE": "Supprimées définitivement",
  "USER_DELETE__GALLERY_PROMPT": "L'option « Rendre publique » rend publiques toutes les présentations privées ou en lecture seule de l'utilisateur. « Supprimer toutes les présentations privées » supprime de façon permanente les présentations privées et rend publiques les présentations en lecture seule.",
  "USER_DELETE__GALLERY_PROMPT_1": "Les éléments extraits des utilisateurs seront restaurés et rendus accessibles.",
  "USER_DELETE__GALLERY_PROMPT_2": "Les galeries en lecture seule des utilisateurs seront rendues publiques.",
  "USER_DELETE__GALLERY_PROMPT_3": "Les galeries privées des utilisateurs doivent être :",
  "USER_DELETE__MAKE_PUBLIC": "Rendues publiques",
  "USER_DETAILS": "Détails de l'utilisateur",
  "USER_IMPORT": "Importer les utilisateurs",
  "USER_IMPORT_ACCOUNT": "Nom du compte",
  "USER_IMPORT_ACCOUNT_ATTR": "Attribut du compte",
  "USER_IMPORT_EMAIL_ATTR": "Attribut du courrier électronique",
  "USER_IMPORT_IMPORT": "Importer",
  "USER_IMPORT_IMPORT_SELECTED_USERS": "Importer les utilisateurs sélectionnés",
  "USER_IMPORT_MODIFY_SEARCH": "Modifier la recherche",
  "USER_IMPORT_NAME_ATTR": "Attribut du nom de compte",
  "USER_IMPORT_NOTES_ATTR": "Attribut des remarques",
  "USER_IMPORT_PASSWORD": "Mot de passe du compte",
  "USER_IMPORT_PASSWORD_ATTR": "Attribut du mot de passe",
  "USER_IMPORT_SEARCH": "Rechercher",
  "USER_IMPORT_SEARCH_BASE": "Base de recherche",
  "USER_IMPORT_SEARCH_FILTER": "Filtre de recherche",
  "USER_IMPORT_SERVER_ADDRESS": "Adresse du serveur",
  "USER_IMPORT_SPECIFY_LDAP_SERVER": "Spécifier le serveur LDAP",
  "USER_LEVEL_ADMINISTRATOR": "Administrateur du catalogue",
  "USER_LEVEL_EDITOR": "Éditeur",
  "USER_LEVEL_NON_MEMBER": "--",
  "USER_LEVEL_PUBLISHER": "Publisher",
  "USER_LEVEL_READER": "Reader",
  "USER_MANAGE_CATALOGS": "Gérer les catalogues des utilisateurs sélectionnés",
  "USER_MULT_USERS_SELECTED": "Plusieurs utilisateurs sélectionnés",
  "USER_NAME": "Nom d'utilisateur",
  "USER_NEW_USER_DETAILS": "Détails du nouvel utilisateur",
  "USER_NEW_USER_INFO_MSG": "Pour ajouter un utilisateur à des catalogues spécifiques, choisissez Catalogues > Utilisateurs.",
  "USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS": "Ajouter l’utilisateur à tous les catalogues comme:",
  "USER_NO_USERS_SELECTED": "Aucun utilisateur sélectionné",
  "USER_ONLINE": "En ligne",
  "USER_PASSWORD_TOO_SHORT": "Le mot de passe doit contenir au moins un caractère.",
  "USER_PASSWORDS_DO_NOT_MATCH": "Le champ de confirmation du mot de passe doit correspondre au champ du mot de passe.",
  "USER_ROLE": "Niveau d'accès",
  "USER_VIEW_DETAILS": "Afficher/modifier les détails de l'utilisateur",
  "USERS": "Utilisateurs",
  "VALIDATION_FIELD_LENGTH_EXCEEDED": "Ce champ ne peut dépasser 255 caractères.",
  "VALIDATION_MUST_BE_NONEMPTY": "Ce champ est obligatoire.",
  "VIEW_EDIT_MAPPINGS": "Afficher / Modifier le mappage",
  "AUTH.couldNotConnect": "Ne peut se connecter au serveur. Veuillez vérifier l'adresse.",
  "ERROR.serverUnavailable": "Le serveur du portefeuille n’est pas disponible.",
  "ERROR.sessionExpired": "Votre session a expiré.",
  "fileNotFound": "Le fichier n'a pas été trouvé sur le disque.",
  "ERROR.invalidSearchFailed": "La recherche a échoué, car il y a eu un problème avec la demande.",
  "AUTH.loginFailed": "Le nom d'utilisateur et le mot de passe étaient incorrects.",
  "FAULT_CODE.InsufficientPrivileges": "Vous ne disposez pas des autorisations nécessaires pour pouvoir effectuer cette opération.",
  "unexpectedError": "Une erreur inattendue est survenue.",
  "REFRESH": "Actualiser",
  "ALL_CATALOGS": "Tous les catalogues",
  "ALL_SITES": "Tous les sites",
  "ASSET_DOWNLOADS": "Actifs - les plus téléchargés",
  "ASSET_PREVIEWS": "Actifs - Les plus prévisualisés",
  "ASSET_UPLOADS": "Actif - Publications en ligne",
  "DOWNLOAD_REPORT": "Télécharger le rapport",
  "FILE_TYPES": "Types de fichiers",
  "FROM": "Du",
  "SITE": "Site",
  "KEYWORD_STATISTICS": "Statistiques sur les mots-clés",
  "NETPUBLISH_MOST_DOWNLOADED": "NetPublish - Les plus téléchargés",
  "NETPUBLISH_USAGE": "NetPublish - Usage",
  "REPORT_NAME_DELETED_BY": "Actifs - Suppressions",
  "REPORT_NAME_DOWNLOADED_BY": "Actifs - Téléchargements",
  "REPORT_DESCRIPTION_ASSET_PREVIEWS": "Ce rapport identifie les ressources qui ont été prévisualisées et combien de fois chacune a été prévisualisée.",
  "REPORT_DESCRIPTION_ASSET_UPLOADS": "Ce rapport identifie les ressources téléchargées, les utilisateurs qui les ont téléchargées et à quel moment.",
  "REPORT_DESCRIPTION_DELETED_BY": "Ce rapport identifie les ressources supprimées, les utilisateurs qui les ont supprimées età quel moment.",
  "REPORT_DESCRIPTION_DOWNLOADED_BY": "Ce rapport identifie les ressources téléchargées, les utilisateurs qui les ont téléchargées età quel moment.",
  "REPORT_DESCRIPTION_DOWNLOADED": "Ce rapport identifie les ressources qui ont été téléchargées et combien de fois chacune a été téléchargée.",
  "REPORT_DESCRIPTION_KEYWORD": "Ce rapport identifie tous les mots-clés dans un catalogue et dénombre les ressources auxquelles ils sont appliqués.",
  "REPORT_DESCRIPTION_USAGE": "Ce rapport identifie quels utilisateurs ont téléchargé quelles ressources, et quand.",
  "REPORT_DESCRIPTION_FILE_TYPES": "Ce rapport identifie vos types de fichiers les plus courants et l'espace disque qu'ils occupent.",
  "REPORT_DESCRIPTION_SEARCH_TERMS": "Ce rapport identifie les mots et expressions les plus courants que vos utilisateurs recherchent.",
  "SEARCH_TERMS": "Termes de recherche",
  "TO": "Au",
  "VIEW_REPORT": "Voir le rapport",
  "REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE": "Révoquer l'adhésion",
  "REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG": "Supprimer l’utilisateur du catalogue ?\nLes éléments extraits des utilisateurs dans ce catalogue seront restaurés et rendus accessibles.",
  "CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG": "Voulez-vous vraiment modifier le rôle de l’utilisateur dans le catalogue ? Cette action risque de détruire les données de l’utilisateur si l'accès ou les autorisations liés au nouveau rôle sont réduits.",
  "DUPLICATE_FIELD_NAME_ERROR": "Duplication du nom du champ",
  "EXTENSIS_CONTACT_US_URL": "https://www.extensis.com/fr/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option",
  "EXTENSIS_SUPPORT_URL": "https://help.extensis.com/hc/fr/requests/new",
  "LIC_CONTACT_CUSTOMER_SUCCESS_1": "Pour obtenir de l'aide sur le renouvellement de votre compte, veuillez nous contacter au",
  "LIC_CONTACT_CUSTOMER_SUCCESS_2": "et votre Customer Success Manager vous contactera dans un délai d'un jour ouvrable.",
  "LIC_ERROR_GET_ACCOUNT": "Un problème s’est produit pour obtenir votre compte Extensis.",
  "LIC_ERROR_GET_LICENSES": "Un problème s’est produit lors de la récupération de vos licences Extensis.",
  "LIC_SET_EXTENSIS_ACCOUNT": "Définir le compte Extensis",
  "LIC_SET_ACCOUNT": "Définir un Compte",
  "LIC_REMOVE_ACCOUNT": "Supprimer le Compte",
  "LIC_ACCOUNT": "Adresse email",
  "LIC_PASSWORD": "Mot de passe",
  "LIC_SYSTEM_ID": "ID système",
  "LIC_SET_ACCOUNT_ERROR": "Un problème s’est produit lors de la configuration de votre compte Extensis. Veuillez vérifier les identifiants et réessayer.",
  "LIC_SET_SYSTEM_TITLE": "Sélectionnez votre système Extensis",
  "PDL_noPredefinedValues": "Aucune valeur prédéfinie",
  "PDL_editPredefinedListPlaceholder": "Modifier la liste prédéfinie",
  "PDL_importPredefinedValues": "Importer des valeurs prédéfinies",
  "PDL_exportPredefinedValues": "Exporter des valeurs prédéfinies",
  "PDL_removeNestedValueConfirmation": "Supprimer les valeurs sélectionnées?\nElles comportent des valeurs imbriquées qui seront également supprimées.",
  "PDL_wrongPdlImportFormat": "Le fichier sélectionné ne contient pas de données textuelles. Veuillez sélectionner un fichier texte."
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/translations/fr.js